import { render, staticRenderFns } from "./search-results-component.vue?vue&type=template&id=7f8f54af&"
import script from "./search-results-component.vue?vue&type=script&lang=ts&"
export * from "./search-results-component.vue?vue&type=script&lang=ts&"
import style0 from "./search-results-component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports